<template>
    <article class="usps-container" :style="style">
        <div class="usps">
            <WatsonAtomDynamicText
                v-if="heading"
                :text="heading"
                :typography="props.typography.heading"
                class="usps__heading"
            />
            <div class="usps__main">
                <WatsonAtomDynamicText
                    v-if="subheading"
                    :text="subheading"
                    :typography="props.typography.subheading"
                    class="usps__subheading"
                />
                <ul
                    v-if="items.length"
                    class="usps__list"
                >
                    <li
                        v-for="(item, index) in items"
                        :key="index"
                        class="usps__item"
                    >
                        <WatsonAtomImage
                            v-if="item.image"
                            :content="item.image"
                            class="usps__item-image"
                        />
                        <!-- eslint-disable vue/no-v-html -->
                        <div
                            class="usps__item-text"
                            v-html="item.text"
                        ></div>
                    </li>
                </ul>
            </div>
            <div
                v-if="reviewsEnabled"
                class="usps__reviews"
            >
                <WatsonMoleculeReviewCompany
                    v-if="reviewsEnabled"
                    :type-of-company="typeOfCompany"
                    :number-of-stars="numberOfStars"
                    :dark-mode="darkMode"
                    :show-amount="showAmount"
                    :amount="amount"
                    :reviews-text-color="reviewsTextColor"
                />
            </div>
        </div>
    </article>
</template>

<script setup>
import { computed } from 'vue';
import WatsonMoleculeReviewCompany from '@molecules/review-company/watson-molecule-review-company.vue';
import WatsonAtomImage from '@atoms/image/watson-atom-image.vue';
import WatsonAtomDynamicText from '@atoms/dynamic-text/watson-atom-dynamic-text.vue';

const props = defineProps({
    items: {
        type: Array,
        required: false,
        default: () => [],
    },
    heading: {
        type: String,
        required: false,
        default: null,
    },
    subheading: {
        type: String,
        required: false,
        default: null,
    },
    reviewsEnabled: {
        type: Boolean,
        required: false,
        default: false,
    },
    typeOfCompany: {
        type: String,
        required: false,
        default: null,
    },
    numberOfStars: {
        type: Number,
        required: false,
        default: 5,
    },
    darkMode: {
        type: Boolean,
        required: false,
        default: false,
    },
    showAmount: {
        type: Boolean,
        required: false,
        default: true,
    },
    amount: {
        type: String,
        required: false,
        default: 'Over 100+ reviews',
    },
    background: {
        type: String,
        required: false,
        default: null,
    },
    headingColor: {
        type: String,
        required: false,
        default: null,
    },
    subheadingColor: {
        type: String,
        required: false,
        default: null,
    },
    itemsColor: {
        type: String,
        required: false,
        default: null,
    },
    reviewsTextColor: {
        type: String,
        required: false,
        default: null,
    },
    dividerColor: {
        type: String,
        required: false,
        default: null,
    },
    typography: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});

const style = computed(() => ({
    '--background': props.background || 'initial',
    '--heading-color': props.headingColor || 'initial',
    '--subheading-color': props.subheadingColor || 'initial',
    '--items-color': props.itemsColor || 'initial',
    '--divider-color': props.dividerColor || 'initial',
}));
</script>

<style lang="scss">
@use 'watson-theme-usps';
</style>
